import script from "./NoticiasHome.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiasHome.vue?vue&type=script&setup=true&lang=js"

import "./NoticiasHome.vue?vue&type=style&index=0&id=046ea2dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-046ea2dc"]])

export default __exports__